import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ConnectionsService } from '../services/connections.services';
import * as ConnectionsActions from './connections.actions';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../shared/services/toast.service';

@Injectable()
export class ConnectionsEffects {
  constructor(private actions$: Actions,
      private connectionsService: ConnectionsService,
      private toastService: ToastService,
      private translate: TranslateService) {}

  requestConnectionsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(ConnectionsActions.requestConnection),
    switchMap((action) =>
      this.connectionsService.sendConnection(action.connection).pipe(
        map(connection => {
          this.toastService.Success(this.translate.instant("connection.invite.sent"), '');
          return ConnectionsActions.requestConnectionSentSuccess({connection})
        }),
        catchError(() => of(ConnectionsActions.requestConnectionSentFailure({ error: 'Invalid credentials' })))
      )
    )
  ));

  getConnectionsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(ConnectionsActions.getConnections),
    switchMap(() =>
      this.connectionsService.getConnections().pipe(
        map(connections => ConnectionsActions.getConnectionsSuccess({connections}))
      )
    )
  ));

  searchConnectionsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(ConnectionsActions.searchConnection),
    switchMap((action) =>
      this.connectionsService.searchConnection(action.searchCriteria).pipe(
        map(searchResults => ConnectionsActions.searchConnectionSentSuccess({searchResults}))
      )
    )
  ));

  deleteConnectionEffect$ = createEffect(() => this.actions$.pipe(
      ofType(ConnectionsActions.deleteConnection),
      switchMap((action) =>
        this.connectionsService.deleteConnection(action.connectionId).pipe(
          map(connection => {
            this.toastService.Success(this.translate.instant("connection.myconnections.cancelled"), '');
            return ConnectionsActions.deleteConnectionSentSuccess({connection})
          }),
          catchError(() => of(ConnectionsActions.deleteConnectionSentFailure({ error: 'Error cancelling connection' })))
        )
      )
    )
  );

  getPendingConnectionsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(ConnectionsActions.getPendingConnection),
    switchMap(() =>
      this.connectionsService.getConnectionInvitations().pipe(
        map(connections => ConnectionsActions.getPendingConnectionSuccess({connections}))
      )
    )
  ));

  addTagToConnectionsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(ConnectionsActions.addTagToConnection),
    switchMap((action) =>
      this.connectionsService.addTagToConnections(action.tagId, action.selectedConnections).pipe(
        map(tag => {
          this.toastService.Success(this.translate.instant("tag.attached"), '');
          return ConnectionsActions.getConnections();
        }),
        catchError(() => of(ConnectionsActions.addTagToConnectionFailure({ error: 'Error cancelling tag' })))
      )
    )
  ));

  removeTagToConnectionsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(ConnectionsActions.removeTagToConnection),
    switchMap((action) =>
      this.connectionsService.removeTagToConnections(action.connectionTagId).pipe(
        map(tag => {
          this.toastService.Success(this.translate.instant("tag.deleted"), '');
          return ConnectionsActions.getConnections();
        }),
        catchError(() => of(ConnectionsActions.removeTagToConnectionFailure({ error: 'Error cancelling tag' })))
      )
    )
  ));
}
